export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function cleanString(string: string): string {
  return string.replace(/[-_/]/g, ' ');
}

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const invalidEmailDomains = ['gmail', 'hotmail', 'yahoo', 'outlook'];

export const isCorporateEmail = (email: string) => {
  const domain = email.split('@')[1];
  return !invalidEmailDomains.some((invalidDomain) =>
    domain.includes(invalidDomain),
  );
};
